import {
  Control,
  Controller,
  FieldValues,
  Path,
  RegisterOptions,
} from 'react-hook-form';
import PhoneFields from './PhoneFields';
import FormError from '../../FormError';
import useFormPhoneNumber from '../../FormPhoneNumber/hooks/useFormPhoneNumber';

type Props<T extends FieldValues> = {
  name: Path<T>;
  control: Control<T>;
  error?: string;
  value?: string;
  rules?: RegisterOptions;
  required?: boolean;
  label?: string;
  placeholder?: string;
  selectInputLabel?: string;
};

const FormPhoneNumber = <T extends FieldValues>({
  name,
  control,
  error,
  value,
  required = false,
  label,
  placeholder,
  selectInputLabel,
}: Props<T>) => {
  const { validatePhoneNumber } = useFormPhoneNumber(required);

  return (
    <Controller
      control={control}
      name={name}
      rules={{
        required: required && 'errors.input.required',
        validate: (phone) => validatePhoneNumber(phone as string),
      }}
      render={({ field }) => {
        const handleChange = field.onChange;
        return (
          <div>
            <PhoneFields
              value={value ?? ''}
              onChange={handleChange}
              error={error}
              label={label}
              seletInputLabel={selectInputLabel}
              placeholder={placeholder}
            />
            <FormError
              message={error ?? ''}
              data-testid={`${name}-form-error`}
            />
          </div>
        );
      }}
    />
  );
};

export default FormPhoneNumber;
